module.exports = __webpack_public_path__ + "static/media/CTLA_1-127w.19fc0e2a.webp";